export default __webpack_public_path__ + "static/media/next.143b8d28.svg";